/**
 * Idempotency-key helper for the one-shot `instant_purchase` endpoint.
 *
 * Semantics (enforced by the call sites, not here):
 *   • ONE key per ONE purchase attempt.
 *   • STABLE across a retry of THAT attempt — the Retry button reuses the
 *     same key so the backend collapses a re-send into the original order
 *     instead of charging twice.
 *   • NEW for a fresh purchase — every distinct RIP click / Open Next Pack
 *     mints a new key.
 *
 * The backend treats `X-Idempotency-Key` as optional, so a missing
 * `crypto.randomUUID` (ancient browser) degrades gracefully to "no key"
 * rather than throwing — the purchase still goes through, just without the
 * dedupe guarantee.
 */
export function newIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID. Not cryptographically
  // strong, but a unique-enough client token for request dedupe.
  return `ip-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
